/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ClaimApiConfiguration } from '../claim-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ClmClaimInsuredObjectRequestDto } from '../models/clm-claim-insured-object-request-dto';


/**
 * the ClaCommandCreateInsuredObject API
 */
@Injectable({
  providedIn: 'root',
})
export class ClaCommandCreateInsuredObjectService extends BaseService {
  constructor(
    config: ClaimApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation createInsuredObject
   */
  static readonly CreateInsuredObjectPath = '/claim/{claimId}/insured-object';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createInsuredObject()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createInsuredObject$Response(params: {
    claimId: string;
    body: ClmClaimInsuredObjectRequestDto
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ClaCommandCreateInsuredObjectService.CreateInsuredObjectPath, 'post');
    if (params) {
      rb.path('claimId', params.claimId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createInsuredObject$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createInsuredObject(params: {
    claimId: string;
    body: ClmClaimInsuredObjectRequestDto
  },
  context?: HttpContext

): Observable<void> {

    return this.createInsuredObject$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
